/**
 * Kategorien-Tab der Buchhaltungsseite
 */

import { Plus, Tag } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent } from '@/components/ui/card';

export function KategorienTab({ kategorien, openChildTab }) {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <div>
          <p className="text-sm text-slate-500">{kategorien.length} Kategorien</p>
          <p className="text-xs text-slate-400">Kategorien werden automatisch mit Maßnahmen verknüpft</p>
        </div>
        <Button size="sm" onClick={() => openChildTab('/schnellerfassung/kategorie', { title: 'Neue Kategorie', forceNew: true })}>
          <Plus className="w-4 h-4 mr-2" /> Kategorie erstellen
        </Button>
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {kategorien.map(k => (
          <Card key={k.id} className={`${k.typ === 'einnahme' ? 'border-l-4 border-l-green-500' : k.typ === 'ausgabe' ? 'border-l-4 border-l-red-500' : ''}`}>
            <CardContent className="py-3 px-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <Tag className="w-4 h-4 text-slate-400" />
                  <span className="font-medium text-slate-700">{k.name}</span>
                </div>
                <Badge variant="outline" className="text-xs">
                  {k.typ === 'einnahme' ? 'Einnahme' : k.typ === 'ausgabe' ? 'Ausgabe' : 'Neutral'}
                </Badge>
              </div>
              {k.massnahme_typ && (
                <p className="text-xs text-slate-400 mt-1">
                  Verknüpft mit Maßnahme: {k.massnahme_typ}
                </p>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
